import { ApprovalCard } from "@/components/ApprovalCard";
import { usePendingApprovals } from "@/hooks/useApprovals";

export function ApprovalsPage() {
  const query = usePendingApprovals();

  if (query.isLoading) {
    return <div className="text-sm text-muted-foreground">Cargando…</div>;
  }

  if (query.error) {
    return (
      <div className="rounded border border-destructive/40 bg-destructive/10 p-4 text-sm text-destructive">
        Error: {(query.error as Error).message}
      </div>
    );
  }

  const items = query.data ?? [];

  if (items.length === 0) {
    return (
      <div className="rounded-lg border bg-card p-6 text-center text-sm text-muted-foreground">
        Sin acciones pendientes de aprobación.
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-2xl font-semibold">Aprobaciones pendientes</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Acciones propuestas por AROC esperando decisión humana.
        </p>
      </div>
      <div className="space-y-3">
        {items.map((approval) => (
          <ApprovalCard key={approval.id} approval={approval} />
        ))}
      </div>
    </div>
  );
}
